import { InformationIcon } from '@/components/icons/information';
import { Tooltip, TooltipArrow, TooltipContent, TooltipPortal, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

export function LockedFieldTooltip({ ariaLabel, message }: { ariaLabel: string; message: string }) {
  return (
    <TooltipProvider>
      <Tooltip delayDuration={0}>
        <TooltipTrigger asChild>
          <button type="button" aria-label={ariaLabel} className="text-secondary-text inline-flex">
            <InformationIcon size={16} />
          </button>
        </TooltipTrigger>
        <TooltipPortal>
          <TooltipContent side="top" className="bg-default-text max-w-[240px] text-xs text-white">
            {message}
            <TooltipArrow className="fill-default-text" />
          </TooltipContent>
        </TooltipPortal>
      </Tooltip>
    </TooltipProvider>
  );
}
